import React from 'react'
import { useTranslation } from 'react-i18next'

function ResizableHeader({ label, align = 'left', resizing = false, onResizeStart }) {
  const { t } = useTranslation()

  const onPointerDown = event => {
    event.preventDefault()
    event.stopPropagation()
    onResizeStart(event.clientX)
  }

  return (
    <div className={`visits-col-header${align === 'center' ? ' visits-col-header--center' : ''}`}>
      <span className="visits-col-header-label">{label}</span>
      <span
        role="separator"
        aria-orientation="vertical"
        aria-label={t('Resize column')}
        className={`visits-col-resize-handle${resizing ? ' is-resizing' : ''}`}
        onPointerDown={onPointerDown}
      />
    </div>
  )
}

export default ResizableHeader
